import { render } from "./hoverEffect11.vue?vue&type=template&id=15054d07"
import script from "./hoverEffect11.vue?vue&type=script&lang=js"
export * from "./hoverEffect11.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__